/**
 * Сваляне на таблица за Excel. Българският Excel чете CSV с „;" и десетична
 * запетая; знакът BOM в началото казва, че файлът е UTF-8 — без него
 * кирилицата излиза нечетима. Текст, който започва с „=", „+", „-" или „@",
 * се предшества с апостроф, за да не стане формула (име на клиент „=1+1").
 */
export type CsvCell = string | number | null | undefined;

function cell(value: CsvCell): string {
  if (value === null || value === undefined) return '';
  if (typeof value === 'number') return Number.isFinite(value) ? String(value).replace('.', ',') : '';
  const text = /^[=+\-@]/.test(value) ? `'${value}` : value;
  return /[;"\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

export function toCsv(header: string[], rows: CsvCell[][]): string {
  return [header, ...rows].map((row) => row.map(cell).join(';')).join('\r\n');
}

export function downloadCsv(fileName: string, header: string[], rows: CsvCell[][]): void {
  const blob = new Blob([`﻿${toCsv(header, rows)}`], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/** Сума от центове в евро с два знака — за колона в Excel. */
export const euros = (minor: number | null | undefined): number | null =>
  minor === null || minor === undefined ? null : Math.round(minor) / 100;
